(() => {
  if (window.LasgymRefinedProduct) return;
  const initialized = new WeakSet();
  const refinePaymentWidgets = root => {
    const paymentGroup = root.querySelector('.LGProductPayments');
    if (!paymentGroup) return;
    const logos = {scalapay: paymentGroup.dataset.lgScalapayLogo, klarna: paymentGroup.dataset.lgKlarnaLogo};
    const klarnaAmounts = new Map();
    let currentVariant;
    try {
      currentVariant = JSON.parse(root.querySelector('[data-product-json]')?.textContent || '{}').product?.selected_or_first_available_variant;
    } catch { currentVariant = null; }
    const initKlarnaAmount = widget => {
      const shadow = widget.shadowRoot;
      if (!shadow || klarnaAmounts.has(widget)) return;
      const state = { pending: false, update: null };
      const update = () => {
        const message = shadow.querySelector('.text');
        let summary = shadow.querySelector('[data-lg-klarna-amount]');
        const amount = Number(widget.getAttribute('data-purchase-amount'));
        const offer = (message?.textContent || '').replace(/\s+/g, ' ').trim();
        const eligible = widget.isConnected && !state.pending && root.dataset.lgPaymentCurrency === 'EUR' && currentVariant?.available && Number.isInteger(amount) && amount > 0 && amount === Number(currentVariant.price) && /\b3 pagamenti a interessi 0%(?=\s|$|[.,;])/i.test(offer) && message?.getClientRects().length && getComputedStyle(message).visibility !== 'hidden';
        if (!eligible) {
          if (summary && !summary.hidden) summary.hidden = true;
          return;
        }
        if (!summary) {
          summary = document.createElement('p');
          summary.dataset.lgKlarnaAmount = '';
          summary.style.cssText = 'margin:0 0 6px;font:600 12px/1.5 Arial,Helvetica,sans-serif;color:#111;text-align:center';
          message.insertAdjacentElement('beforebegin', summary);
        }
        const installment = new Intl.NumberFormat('it-IT', {style:'currency',currency:'EUR'}).format(Math.round(amount / 3) / 100);
        const text = '3 rate da ' + (amount % 3 ? 'circa ' : '') + installment;
        if (summary.textContent !== text) summary.textContent = text;
        if (summary.hidden) summary.hidden = false;
      };
      state.update = update;
      klarnaAmounts.set(widget, state);
      const observer = new MutationObserver(records => {
        let nativeChanged = false;
        for (const record of records) {
          if (record.target === widget) {
            if (record.oldValue !== widget.getAttribute('data-purchase-amount')) state.pending = true;
            continue;
          }
          const target = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
          if (target?.closest('[data-lg-klarna-amount],style')) continue;
          const nodes = [...record.addedNodes, ...record.removedNodes];
          if (record.type === 'childList' && nodes.length && nodes.every(node => node.nodeType === Node.ELEMENT_NODE && (node.matches('[data-lg-klarna-amount],style')))) continue;
          nativeChanged = true;
        }
        if (nativeChanged) state.pending = false;
        update();
      });
      observer.observe(shadow, {childList:true,subtree:true,characterData:true});
      observer.observe(widget, {attributes:true,attributeOldValue:true,attributeFilter:['data-purchase-amount']});
      update();
    };
    root.addEventListener('variant:changed', event => {
      currentVariant = event.detail?.variant || null;
      klarnaAmounts.forEach((state, widget) => {
        if (!widget.isConnected) { klarnaAmounts.delete(widget); return; }
        state.pending = !currentVariant?.available || Number(widget.getAttribute('data-purchase-amount')) !== Number(currentVariant.price);
        state.update();
      });
    });
    const styleWidget = (widget, provider, attempts = 0) => {
      if (!widget.isConnected) return;
      const shadow = widget.shadowRoot;
      if (!shadow) {
        if (attempts < 30) setTimeout(() => styleWidget(widget, provider, attempts + 1), 200);
        return;
      }
      if (provider === 'klarna') initKlarnaAmount(widget);
      if (shadow.querySelector('[data-lg-payment-style]')) return;
      const logo = logos[provider];
      if (!logo) return;
      const image = 'url(' + JSON.stringify(logo) + ')';
      const style = document.createElement('style');
      style.dataset.lgPaymentStyle = provider;
      style.textContent = provider === 'klarna' ? `
        .container{border:0!important;border-radius:0!important;padding:0!important;display:flex!important;flex-direction:column!important;gap:10px!important;align-items:center!important;text-align:center!important;font:400 12px/1.5 Arial,Helvetica,sans-serif!important;color:#111!important;background:#fff!important}
        .text-wrapper{margin:0!important;width:100%}
        .badge{width:96px;height:30px;background:${image} center/contain no-repeat}
        .badge svg{width:96px!important;height:30px!important;opacity:0}
        .text{font:400 12px/1.5 Arial,Helvetica,sans-serif!important;text-align:center!important;color:#111!important}
        .link{display:block!important;margin:5px auto 0!important;font:400 11px/1.5 Arial,Helvetica,sans-serif!important;text-align:center!important;color:#666!important}
      ` : `
        :host>div{padding:0!important;font-family:Arial,Helvetica,sans-serif!important}
        article[data-testid="product-widget"]{border:0!important;border-radius:0!important;padding:0!important;background:#fff!important;color:#111!important;font:400 12px/1.5 Arial,Helvetica,sans-serif!important;gap:6px!important}
        article[data-testid="product-widget"]>div:first-child{flex-direction:column!important;align-items:center!important;gap:5px!important}
        article[data-testid="product-widget"]>div:first-child>div:first-child{flex-direction:column!important;align-items:center!important;gap:10px!important;width:100%}
        article[data-testid="product-widget"]>div:first-child>div:first-child>span:first-child{width:114px;height:30px;background:${image} center/contain no-repeat}
        svg[data-testid="scalapay-logo-black"]{opacity:0!important;width:114px!important;height:30px!important;margin:0!important;padding:0!important}
        article[data-testid="product-widget"]>div:first-child>div:first-child>div{display:flex!important;flex-direction:column!important;align-items:center!important;text-align:center!important}
        article[data-testid="product-widget"]>div:first-child>div:last-child{margin:0!important}
        [data-testid="product-widget-label-2"]{color:#666!important;font-size:11px!important}
        article[data-testid="product-widget"] button{min-height:24px}
        article[data-testid="product-widget"] button svg{width:18px!important;height:18px!important}
      `;
      shadow.append(style);
    };
    [['scalapay-widget', 'scalapay'], ['klarna-placement', 'klarna']].forEach(([tag, provider]) => {
      customElements.whenDefined(tag).then(() => {
        paymentGroup.querySelectorAll(tag).forEach(widget => styleWidget(widget, provider));
      });
    });
    const observer = new MutationObserver(() => {
      paymentGroup.querySelectorAll('scalapay-widget').forEach(widget => styleWidget(widget, 'scalapay'));
      paymentGroup.querySelectorAll('klarna-placement').forEach(widget => styleWidget(widget, 'klarna'));
    });
    observer.observe(paymentGroup, {childList:true,subtree:true});
  };
  const refineGallery = root => {
    let boundSwiper;
    let refreshFrame;
    const update = () => {
      const gallery = root.querySelector('.ProductGallery--carousel');
      const meta = gallery?.querySelector('[data-lg-gallery-meta]');
      const swiper = root.productSlideshow?.carouselInstance;
      if (!meta || !swiper || swiper.destroyed) return;
      const thumbs = [...gallery.querySelectorAll('.ProductGallery__Thumbs [data-lg-media-id]')];
      const index = swiper.realIndex || 0;
      const active = thumbs[index] || gallery.querySelector('.ProductGallery__Carousel .Carousel__Item--active');
      const total = thumbs.length || Number(meta.dataset.lgGalleryTotal) || 1;
      const current = meta.querySelector('[data-lg-gallery-current]');
      const count = meta.querySelector('[data-lg-gallery-total]');
      const caption = meta.querySelector('[data-lg-gallery-caption]');
      if (current) current.textContent = String(index + 1).padStart(2, '0');
      if (count) count.textContent = String(total).padStart(2, '0');
      if (caption && active?.dataset.lgMediaCaption) caption.textContent = active.dataset.lgMediaCaption;
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', i === index ? 'true' : 'false'));
    };
    const bind = () => {
      if (!root.isConnected) return;
      const swiper = root.productSlideshow?.carouselInstance;
      if (swiper && !swiper.destroyed && swiper !== boundSwiper) {
        if (boundSwiper && !boundSwiper.destroyed) boundSwiper.off('realIndexChange slideChangeTransitionEnd virtualUpdate', update);
        boundSwiper = swiper;
        swiper.on('realIndexChange slideChangeTransitionEnd virtualUpdate', update);
      }
      update();
    };
    const schedule = () => {
      cancelAnimationFrame(refreshFrame);
      refreshFrame = requestAnimationFrame(bind);
    };
    customElements.whenDefined('section-product').then(schedule);
    root.addEventListener('variant:changed', schedule);
    root.addEventListener('keydown', event => {
      const thumb = event.target.closest('.ProductGallery__Thumbs [data-lg-media-id]');
      if (!thumb || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      const thumbs = [...thumb.parentElement.querySelectorAll('[data-lg-media-id]')];
      root.productSlideshow?.selectCell(thumbs.indexOf(thumb));
    });
  };
  const refineBundles = root => {
    let frame;
    const update = () => {
      root.querySelectorAll('#revy-bundles-wrapper .rbu-sb-container').forEach(container => {
        const count = [...container.children].filter(child => child.classList.contains('rbu-sb-tier-container')).length;
        if (count) container.style.setProperty('--lg-bundle-columns', String(count));
        const button = container.querySelector('.rbu-sb-btn');
        if (button) {
          button.setAttribute('role', 'button');
          button.setAttribute('tabindex', '0');
          button.setAttribute('aria-disabled', String(button.dataset.disabled === 'true'));
        }
      });
    };
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    };
    new MutationObserver(schedule).observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-disabled']});
    root.addEventListener('keydown', event => {
      const button = event.target.closest('#revy-bundles-wrapper .rbu-sb-btn');
      if (!button || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      if (button.dataset.disabled !== 'true') button.click();
    });
    update();
  };
  const initProduct = root => {
    if (initialized.has(root)) return;
    initialized.add(root);
    refinePaymentWidgets(root);
    refineGallery(root);
    refineBundles(root);
    let launcherFrame;
    const placeClubLauncher = () => {
      cancelAnimationFrame(launcherFrame);
      launcherFrame = requestAnimationFrame(() => {
        const launcher = document.getElementById('smile-ui-lite-launcher-frame-container');
        const summary = root.querySelector('.ProductDesign');
        if (!launcher || !summary) return;
        const a = launcher.getBoundingClientRect(), b = summary.getBoundingClientRect();
        const overlaps = a.right > b.left && a.left < b.right && a.bottom > b.top && a.top < b.bottom;
        if (overlaps) {
          launcher.style.setProperty('visibility', 'hidden', 'important');
          launcher.dataset.lgPurchaseOverlap = 'true';
        } else if (launcher.dataset.lgPurchaseOverlap) {
          launcher.style.removeProperty('visibility');
          delete launcher.dataset.lgPurchaseOverlap;
        }
      });
    };
    document.addEventListener('scroll', placeClubLauncher, {passive:true});
    window.addEventListener('resize', placeClubLauncher, {passive:true});
    new MutationObserver(placeClubLauncher).observe(document.body, {childList:true,subtree:true});
    placeClubLauncher();
    root.addEventListener('click', event => {
      if (!event.target.closest('[data-lg-open-size-assistant]')) return;
      const trigger = root.querySelector('lasgym-size-assistant .lgsa-trigger');
      if (trigger && !trigger.hidden) { event.preventDefault(); trigger.click(); }
    });
    root.addEventListener('variant:changed', event => {
      const variant = event.detail?.variant;
      if (!variant) {
        root.querySelectorAll('[data-lg-live-stock]').forEach(stock => { stock.hidden = true; });
        return;
      }
      root.querySelectorAll('klarna-placement').forEach(placement => {
        const purchaseAmount = String(variant.price);
        if (placement.dataset.purchaseAmount !== purchaseAmount) placement.dataset.purchaseAmount = purchaseAmount;
      });
      if (window.KOSMApp?.updatePurchaseAmount) {
        window.KOSMApp.updatePurchaseAmount(variant.price);
      } else if (window.Klarna?.OnsiteMessaging?.refresh) {
        window.Klarna.OnsiteMessaging.refresh();
      } else if (window.KlarnaOnsiteService?.push) {
        window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
      }
    });
  };
  const loadBestsellers = async element => {
    try {
      const response = await fetch(element.dataset.source, { credentials: 'same-origin' });
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = html.querySelector('[data-lg-bestseller-items] .LGBestsellers__list');
      if (!source) return;
      const currentProduct = element.dataset.productId;
      source.querySelectorAll('[data-bestseller-id]').forEach(card => {
        if (card.dataset.bestsellerId === currentProduct) card.remove();
      });
      if (!source.children.length) return;
      element.querySelector('[data-lg-bestseller-items]').replaceChildren(source);
      window.LasgymWishlist?.refresh?.();
    } catch {
      return;
    }
  };
  const initBestsellers = element => {
    if (initialized.has(element)) return;
    initialized.add(element);
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        loadBestsellers(element);
      }, { rootMargin: '400px' });
      observer.observe(element);
    } else loadBestsellers(element);
  };
  const init = (scope = document) => {
    scope.querySelectorAll('.LGRefinedProduct').forEach(initProduct);
    scope.querySelectorAll('[data-lg-bestsellers]').forEach(initBestsellers);
  };
  window.LasgymRefinedProduct = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
